import React from "react";

import { auth } from '../../firebase';
import { Router } from "@reach/router";

import YourAccount from '../account/YourAccount';
import YourOrders from '../orders/YourOrders';
import SignInProtectedRoutes from '../registration/SignInProtectedRoutes';

/**
 *  Require a logged in user for /account, /orders etc.
 */
const ProtectedRoutes = () => {
  
  const [loggedIn, setLoggedIn] = React.useState(false);

  React.useEffect(() => {
    const user = auth.currentUser; 
    setLoggedIn(user && !user.isAnonymous);
  }, [loggedIn]) 

  return (
      <Router>
        { loggedIn
          ? <>
              <YourAccount path="account" />
              <YourOrders path="orders" />
            </>  
          : <>
              <SignInProtectedRoutes path="account" onSignIn={() => { setLoggedIn(true)}} />
              <SignInProtectedRoutes path="orders" onSignIn={() => { setLoggedIn(true)}} />
            </>
        }        
      </Router>  
  ); 
}

export default ProtectedRoutes;